export const assets = {
    images: [
        'crystals.svg',
        'opensea.webp',
        'profile.webp',
        'rarible.webp'
    ],
    owners: [
        'owner-1.webp',
        'owner-2.webp',
        'owner-3.webp',
        'owner-4.webp',
        'owner-5.webp',
        'owner-6.webp'
    ],
    svg: {
        chains: [
            'AVAX.svg',
            'BNB.svg',
            'ETH.svg',
            'GMT.svg',
            'MATIC.svg',
            'POL.svg',
            'POLYGON.svg',
            'XSOLLAZK.svg'
        ],
        icon: [
            'air.svg',
            'arrow-l-r.svg',
            'arrow-r-l.svg',
            'arrow-t-r.svg',
            'basket.svg',
            'cart.svg',
            'caution.svg',
            'chain.svg',
            'check-mark.svg',
            'check.svg',
            'chevron-down.svg',
            'chevron-r-l-d.svg',
            'clock.svg',
            'close-circled.svg',
            'close.svg',
            'copy.svg',
            'edit.svg',
            'external-link.svg',
            'external-window.svg',
            'falling-star.svg',
            'file.svg',
            'fill-star.svg',
            'filter.svg',
            'grid-small.svg',
            'grid.svg',
            'hourglass.svg',
            'inventory.svg',
            'link.svg',
            'logo-short.svg',
            'logo.svg',
            'menu.svg',
            'minus.svg',
            'missing.svg',
            'moon.svg',
            'more.svg',
            'opensea.svg',
            'person.svg',
            'plus.svg',
            'search.svg',
            'share.svg',
            'slash.svg',
            'sort.svg',
            'star.svg',
            'sun.svg',
            'switch.svg',
            'to-left.svg',
            'to-r-l.svg',
            'up-down.svg',
            'wallet.svg',
            'warning.svg'
        ],
        logo: [
            'coinbase.svg',
            'discord.svg',
            'etherium.svg',
            'etherscan.svg',
            'instagram.svg',
            'metamask.svg',
            'polygon.svg',
            'solana.svg',
            'soundcloud.svg',
            'spotify.svg',
            'telegram.svg',
            'tezos.svg',
            'twitter.svg',
            'wallet-connect.svg',
            'youtube.svg'
        ],
        placement: [
            'gmbzr-logo-short.svg',
            'gmbzr-logo.svg',
            'xsolla-logo-short.svg',
            'xsolla-logo.svg',
            'xsolla-zk.svg'
        ]
    }
} as const;
